export const generateTimeOptions = () => {
  const options = [];
  for (let hour = 8; hour <= 19; hour++) {
    options.push({
      value: `${hour.toString().padStart(2, '0')}:00`,
      label: `${hour.toString().padStart(2, '0')}:00`,
    });
    if (hour !== 19) {
      options.push({
        value: `${hour.toString().padStart(2, '0')}:30`,
        label: `${hour.toString().padStart(2, '0')}:30`,
      });
    }
  }
  return options;
};
